import { assertNever } from '@kofno/piper';
import { fromNullable, just } from 'maybeasy';
import { MutableRefObject } from 'react';
import { InputActionMeta, MultiValue } from 'react-select';
import { normalizeValue } from '../../../../../NormalizeValue';
import { FilterOption, emptyOption } from './Types';
import { whenGt } from '@execonline-inc/numbers';

export const handleSelectionChange =
  (
    onChange: (value: FilterOption) => void,
    setOptionSelectedState: (selectedValue: FilterOption) => void,
  ) =>
  (selectedOption: FilterOption | MultiValue<FilterOption> | null) => {
    const option = normalizeValue(selectedOption).getOrElseValue(emptyOption);

    setOptionSelectedState(option);
    onChange(option);
  };

export const handleInputChange =
  (
    debouncer: MutableRefObject<NodeJS.Timeout | undefined>,
    setFilteringState: (filterBy: string) => void,
    setReadyState: () => void,
  ) =>
  (input: string, action: InputActionMeta) => {
    switch (action.action) {
      case 'input-change':
        just(input.length)
          .andThen(whenGt(2))
          .do(() => {
            fromNullable(debouncer.current).do(clearTimeout);
            debouncer.current = setTimeout(() => {
              setFilteringState(input);
            }, 500);
          });
        break;
      case 'input-blur':
        setReadyState();
        break;
      case 'menu-close':
      case 'set-value':
        break;
      default:
        assertNever(action.action);
    }
  };
